/* eslint-disable no-extend-native */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import NavigationBar from '../components/NavBar'
import MapsComponent from '../components/googleMaps/MapsComponent'
import SingleDay from '../components/reports/SingleDay'

const Reports = (props) => {
    // encryption
    var CryptoJS = require("crypto-js");

    // get the week function
    Date.prototype.getWeek = function () {
        var firstDate = new Date(this.getFullYear(), 0, 1)
        if (this.getFullYear() === 2021) {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7) - 1
        } else {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7)
        }
    }

    // functions for api requests
    async function postData(url = '', data={}) {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'POST', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
            },
            body: JSON.stringify(data)
        });
        return response ? response.json() : console.log('no reponse')
    };
    async function getData(url = '') {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'GET', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
            }
        });
        return response ? response.json() : console.log('no reponse')
    };
    async function putData(url = '', data={}) {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'PUT', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
            },
            body: JSON.stringify(data)
        });
        return response ? response.json() : console.log('no reponse')
    };

    // local state
    const [ managerList, setManagerList ] = useState([])
    const [ userData, setUserData ] = useState(null)
    const [ managerData, setManagerData ] = useState([])

    // state for changing the data
    const [ timePeriod, setTimePeriod ] = useState(1) 
    const [ timePeriodData, setTimePeriodData ] = useState([])

    // state for db data
    const [ scheduledDates, setScheduledDates ] = useState([])
    const [ validationDates, setValidationDates ] = useState([])
    const [ rentalDates, setRentalDates ] = useState([])
    const [ scheduledFormated, setScheduledFormated ] = useState([])

    // display state 
    const [ daysList, setDaysList ] = useState([])
    const [ scheduleRender, setScheduleRender ] = useState([])
    const [ validationRender, setValidationRender ] = useState([])
    const [ rentalRender, setRentalRender ] = useState([])
    const [ singleDateScreen, setSingleDateScreen ] = useState(null)

    // single date selection
    const [ selectedDate, setSelectedDate ] = useState(new Date())
    const [ weekGate, setWeekGate ] = useState(true)
    const [ managersName, setManagersName ] = useState('')

    // handling the date switching 
    const [ optionsThree, setOptionsThree ] = useState([])
    const [ sunday, setSunday ] = useState(new Date())

    // mapping
    const [ lat, setLat ] = useState(0)
    const [ long, setLong ] = useState(0)
    const [ logInTime, setLogInTime ] = useState('')
    const [ logInDate, setLogInDate ] = useState('')

    // find data for each manager
    const handleFindData = (e, managerId, managerName) => {
        setValidationRender([
            <div className='scheduleRenderContainer'>
                <h3>Validation</h3>
                <div className='complianceLoadingTwo'>
                    <div className='containerForLoader'>
                        <div class="spinner">
                            <div class="bounce1"></div>
                            <div class="bounce5"></div>
                            <div class="bounce4"></div>
                            <div class="bounce3"></div>
                            <div class="bounce2"></div>
                        </div>
                    </div>
                </div>
            </div>
        ])
        setScheduleRender([
            <div className='scheduleRenderContainer'>
                <h3>Rota/Daily</h3>
                <div className='complianceLoadingTwo'>
                    <div className='containerForLoader'>
                        <div class="spinner">
                            <div class="bounce1"></div>
                            <div class="bounce5"></div>
                            <div class="bounce4"></div>
                            <div class="bounce3"></div>
                            <div class="bounce2"></div>
                        </div>
                    </div>
                </div>
            </div>
        ])
        setRentalRender([
            <div className='scheduleRenderContainer'>
                <h3>Rota/Daily</h3>
                <div className='complianceLoadingTwo'>
                    <div className='containerForLoader'>
                        <div class="spinner">
                            <div class="bounce1"></div>
                            <div class="bounce5"></div>
                            <div class="bounce4"></div>
                            <div class="bounce3"></div>
                            <div class="bounce2"></div>
                        </div>
                    </div>
                </div>
            </div>
        ])
        setUserData(null)
        // setScheduleRender([])
        // setValidationRender([])
        // setRentalRender([])
        setManagersName(managerName)
        postData('https://backendpajamas.herokuapp.com/tracker/', {
            ID: managerId
        }).then( response => {
            if (response.data) {
                setUserData(response.data)
            }
        })
    }

    // for changing the data based on time period
    useEffect( () => {
        if (userData) {
            let localTimeSwitchedData = []
            userData.forEach( ele => {
                if (new Date(ele.date).getWeek() === sunday.getWeek()) {
                    localTimeSwitchedData.push(ele)
                } 
            })
            if (localTimeSwitchedData.length > 0) {
                if (localTimeSwitchedData[0].latitude) {
                    setLat(localTimeSwitchedData[0].latitude)
                }
                if (localTimeSwitchedData[0].longitude) {
                    setLong(localTimeSwitchedData[0].longitude)
                }
            }
            setTimePeriodData(localTimeSwitchedData)
            setWeekGate(true)
        }
    }, [userData, sunday])

    // select a specific date
    const handleSelectDate = (e, dateSelection) => {
        setLogInTime(dateSelection.logIn_time[0])
        setLogInDate(dateSelection.date)
        setSelectedDate(new Date(dateSelection.date))
        postData('https://backendpajamas.herokuapp.com/associatedtracker/', {
            week: new Date(dateSelection.date).getWeek(),
            manId: dateSelection.manager_id
        }).then( response => {
            if (response) {
                setScheduledDates(response.scheduleDates)
                setValidationDates(response.validationData)
                setRentalDates(response.rentalData)
                setWeekGate(false)
            }
        })
    }

    // make the inital display
    useEffect( () => {
        let finalLocalDisplayArray = []
        let localDaysList = []
        if (timePeriodData.length > 0) {
            let localId = timePeriodData[0]
            timePeriodData.forEach( ele => {
                localDaysList.push(
                    <div className='singleDateContainer' onClick={(e) => handleSelectDate(e, ele)}>
                        <h3>
                            {new Date(ele.date).toLocaleDateString('en-GB')}
                        </h3>
                    </div>
                )
            })
            postData('https://backendpajamas.herokuapp.com/associatedtracker/', {
                week: sunday.getWeek(),
                manId: localId.manager_id
            }).then( response => {
                if (response) {
                    setScheduledDates(response.scheduleDates)
                    setValidationDates(response.validationData)
                    setRentalDates(response.rentalData)
                }
            })
        }
        setDaysList(localDaysList)
    }, [timePeriodData, sunday])

    // allow for chaning the time period
    const handleChangePeriod = (e, input) => {
        e.preventDefault()
        setWeekGate(true)
        setTimePeriod(input)
    }

    // grab the manager names
    useEffect( () => {
        if (props.superUser) {
            let localArray = []
            getData('https://backendpajamas.herokuapp.com/managers/').then( response => {
                setManagerData(response.results)
                response.results.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1))   
                response.results.forEach( manager => {
                    localArray.push(
                        <div className='managerSelectionSingleContainer' onClick={(e) => handleFindData(e, manager.user_id, manager.name)}>
                            <h3>{manager.name}</h3>
                        </div>
                    )
                }) 
                setManagerList(localArray)
            })
        }
    }, [])

    // return from single day
    const handleSingleDayReturn = () => {
        setSingleDateScreen(null)
    }

    // handle toggling single day inspection
    const handleSingleDayToggle = (e, driverData, dayData) => {
        setSingleDateScreen(
            <SingleDay driverData={driverData} dayData={dayData} returnFromScreen={handleSingleDayReturn} managerList={managerData}/>
        )
    }

    // make the data render
    // async function getData(url = '') {
    //     let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
    //     let originalText = bytes.toString(CryptoJS.enc.Utf8);
    //     const response = await fetch(url, {
    //         method: 'GET', 
    //         mode: 'cors',
    //         cache: 'no-cache',
    //         credentials: 'same-origin',
    //         headers: {
    //             'Content-Type': 'application/json',
    //             'Authorization': `Token ${originalText}`
    //         }
    //     });
    //     return response ? response.json() : console.log('no reponse')
    // };
    // async function putData(url = '', data={}) {
    //     let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
    //     let originalText = bytes.toString(CryptoJS.enc.Utf8);
    //     const response = await fetch(url, {
    //         method: 'PUT', 
    //         mode: 'cors',
    //         cache: 'no-cache',
    //         credentials: 'same-origin',
    //         headers: {
    //             'Content-Type': 'application/json',
    //             'Authorization': `Token ${originalText}`
    //         },
    //         body: JSON.stringify(data)
    //     });
    //     return response ? response.json() : console.log('no reponse')
    // };
    useEffect( () => {
        if (scheduledDates.length > 0) {
            if (!weekGate) {
                async function awaitDataFunction() {
                    const result = Promise.all(scheduledDates.map( ele => {
                        if (new Date(ele.date).toDateString() === selectedDate.toDateString()) {
                            return getData(ele.driver_id).then( response => {
                                return (
                                    <div className='scheduleDateSingle' onClick={(e) => handleSingleDayToggle(e, response, ele)}>
                                        <h3>Name: {response.name ? response.name : ele.driver_id}</h3>
                                        <h3>Route: {ele.route}</h3>
                                        <h3>Location: {ele.location}</h3>
                                        <h3>Miles: {ele.mileage}</h3>
                                        <h3>Finish Mileage: {ele.finish_mileage}</h3>
                                    </div>
                                )
                            })
                        }
                    }))
                    return result
                }
                awaitDataFunction().then( response => {
                    if (response.length > 0) {
                        response.sort((a, b) => a.props.children[0].props.children[1].toLowerCase() > b.props.children[0].props.children[1].toLowerCase() ? 1 : -1)
                        setScheduleRender([
                            <div className='scheduleRenderContainer'>
                                <h3>Rota/Daily</h3>
                                {response}
                            </div>
                        ])
                    }
                })
            } else {
                async function awaitDataFunction() {
                    const result = Promise.all(scheduledDates.map( ele => {
                        return getData(ele.driver_id).then( response => {
                            return (
                                <div className='scheduleDateSingle' onClick={(e) => handleSingleDayToggle(e, response, ele)}>
                                    <h3>Name: {response.name ? response.name : ele.driver_id}</h3>
                                    <h3>Route: {ele.route}</h3>
                                    <h3>Location: {ele.location}</h3>
                                    <h3>Miles: {ele.mileage}</h3>
                                    <h3>Finish Mileage: {ele.finish_mileage}</h3>
                                </div>
                            )
                        })
                    }))
                    return result
                }
                awaitDataFunction().then( response => {
                    if (response.length > 0) {
                        response.sort((a, b) => a.props.children[0].props.children[1].toLowerCase() > b.props.children[0].props.children[1].toLowerCase() ? 1 : -1)   
                        setScheduleRender([
                            <div className='scheduleRenderContainer'>
                                <h3>Rota/Daily</h3>
                                {response}
                            </div>
                        ])
                    }
                })
            }
        } else {
            setScheduleRender([
                <div className='scheduleRenderContainer'>
                    <h3>Rota/Daily</h3>
                    <h3>None</h3>
                </div>
            ])
        }
    }, [scheduledDates, weekGate])

    // make the data render
    useEffect( () => {
        if (validationDates.length > 0) {
            let localArray = []
            if (!weekGate) {
                validationDates.forEach( date => {
                    if (selectedDate.toDateString().includes(date.date)) {
                        localArray.push(
                            <div className='scheduleValidationSingle'>
                                <h3>Day: {date.date}</h3>
                                <h3>Station: {date.station}</h3>
                                <h3>Routes: {date.routes}</h3>
                                <h3>Miles: {date.miles}</h3>
                                <h3>LWP: {date.totalLwp}</h3>
                                <h3>LVP: {date.totalLvp}</h3>
                                <h3>Trainings: {date.totalTraining}</h3>
                                <h3>Support: {date.support}</h3>
                                <h3>R2: {date.R2}</h3>
                                <h3>R4: {date.R4}</h3>
                                <h3>R6: {date.R6}</h3>
                                <h3>Missort 4hr: {date.Missortfourth}</h3>
                                <h3>Missort 6hr: {date.Missortsixth}</h3>
                                <h3>AMZL Late Cancel: {date.DpmoBonus}</h3>
                            </div>
                        )
                    }
                })
                if (localArray.length > 0) {
                    setValidationRender([
                        <div className='scheduleRenderContainer'>
                            <h3>Validation</h3>
                            {localArray}
                        </div>
                    ])
                }
            } else {
                validationDates.forEach( date => {
                    localArray.push(
                        <div className='scheduleValidationSingle'>
                                <h3>Day: {date.date}</h3>
                                <h3>Station: {date.station}</h3>
                                <h3>Routes: {date.routes}</h3>
                                <h3>Miles: {date.miles}</h3>
                                <h3>LWP: {date.totalLwp}</h3>
                                <h3>LVP: {date.totalLvp}</h3>
                                <h3>Trainings: {date.totalTraining}</h3>
                                <h3>Support: {date.support}</h3>
                                <h3>R2: {date.R2}</h3>
                                <h3>R4: {date.R4}</h3>
                                <h3>R6: {date.R6}</h3>
                                <h3>Missort 4hr: {date.Missortfourth}</h3>
                                <h3>Missort 6hr: {date.Missortsixth}</h3>
                                <h3>AMZL Late Cancel: {date.DpmoBonus}</h3>
                        </div>
                    )
                })
                if (localArray.length > 0) {
                    setValidationRender([
                        <div className='scheduleRenderContainer'>
                            <h3>Validation</h3>
                            {localArray}
                        </div>
                    ])
                }
            }
        } else {
            setValidationRender([
                <div className='scheduleRenderContainer'>
                    <h3>Validation</h3>
                    <h3>None</h3>
                </div>
            ])
        }
    }, [validationDates, weekGate])

    // make the data render
    useEffect( () => {
        if (rentalDates.length > 0) {
            if (!weekGate) {
                async function awaitDataFunction() {
                    const result = Promise.all(rentalDates.map( ele => {
                        if (new Date(ele.date).toDateString() === selectedDate.toDateString()) {
                            return getData(ele.driver_id).then( response => {
                                 return (
                                     <div className='scheduleDateSingle'>
                                         <h3>Name: {response.name ? response.name : ele.driver_id}</h3>
                                         <h3>Reg: {ele.registration}</h3>
                                     </div>
                                 )
                            })
                        }
                    }))
                    return result
                }
                awaitDataFunction().then( response => {
                    if (response.length > 0) {
                        response.sort((a, b) => a.props.children[0].props.children[1].toLowerCase() > b.props.children[0].props.children[1].toLowerCase() ? 1 : -1)
                        setRentalRender([
                            <div className='scheduleRenderContainer'>
                                <h3>Rental Van Tracker</h3>
                                {response}
                            </div>
                        ])
                    }
                })
            } else {
                async function awaitDataFunction() {
                    const result = Promise.all(rentalDates.map( ele => {
                       return getData(ele.driver_id).then( response => {
                            return (
                                <div className='scheduleDateSingle'>
                                    <h3>Name: {response.name ? response.name : ele.driver_id}</h3>
                                    <h3>Reg: {ele.registration}</h3>
                                </div>
                            )
                        })
                    }))
                    return result
                }
                awaitDataFunction().then( response => {
                    if (response.length > 0) {
                        response.sort((a, b) => a.props.children[0].props.children[1].toLowerCase() > b.props.children[0].props.children[1].toLowerCase() ? 1 : -1)
                        setRentalRender([
                            <div className='scheduleRenderContainer'>
                                <h3>Rental Van Tracker</h3>
                                {response}
                            </div>
                        ])
                    }
                })
            }
        } else {
            setRentalRender([
                <div className='scheduleRenderContainer'>
                    <h3>Rota/Daily</h3>
                    <h3>None</h3>
                </div>
            ])
        }
    }, [rentalDates, weekGate])

    const handleSelectSunday = (e, dateOne, dateTwo) => {
        setSunday(new Date(dateOne))
    }

    // get sundays
    const getSundaysTwo = () => {
        let sundays = []
        let currentDate = new Date()
        for (let i = -81; i < 40; i++) {
            let dateInner = new Date(currentDate.getFullYear(), currentDate.getMonth(), i)
            if (dateInner.getDay() === 0) {
                sundays.push(
                    <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectSunday(e, `${dateInner.toDateString()}`, `${dateInner.toDateString()}`)}><a href="#0" id="makeMeWhiteli" >Week: {dateInner.getWeek()} | {dateInner.toLocaleDateString('en-GB')}</a></li>
                    )
            }
        }
        return sundays
    }

    // handle dates
    // make the list of sundays for the backend
    useEffect( () => {
        setOptionsThree(getSundaysTwo())
    }, [])

    return ( 
        <>
        {singleDateScreen}
        <div className='home_content'>
            <NavigationBar title='Tracking Report' superUser={props.superUser ? true : false} email={props.user_email}/>
            <div className='main_content_driver_documents'>
                <div className='reportsMainContainer'>
                    <div className='managerSelectionContainer'>
                        {managerList}
                    </div>
                    <div className='temporalSelectionContainer'>
                    <nav className="menu">
                                <ol>
                                    <li className="menu-item" id="makeMeWhite"><a href="#0" id="makeMeWhite">Week: {sunday.getWeek()} | {sunday.toLocaleDateString('en-GB')}</a>
                                        <ol className="sub-menu" id='payrollDropDown'>
                                            {optionsThree}
                                        </ol>
                                    </li>
                                </ol>
                            </nav>
                    </div>
                    <div className='contentContainer'>
                        <div className='listOfDaysContainer'>
                            <h3 style={{margin: '2px'}}>{managersName}</h3>
                            {daysList}
                        </div>
                        <div className='dataChangesContainer'>
                            {scheduleRender}
                            {validationRender}
                            {rentalRender}
                        </div>
                    </div>
                    <div>
                        <MapsComponent 
                            latitude={lat}
                            longitude={long}
                            logInTime={logInTime}
                            logInDate={logInDate}
                        />
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default Reports